<template>
  <div>
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        Group
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">management</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Group</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger" v-model="index">
          <b-tab title="Information" border-variant="primary" >
            <b-card>
              <div class="d-flex flex-wrap align-items-center">
                <div class="title mr-auto">
                  Group Info
                </div>
                <div class="mb7">
                  <span class="float-right">{{model.joined_at | sdate}}</span>
                </div>
              </div>
              <hr>
              <b-row class="mb-2">
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_name">
                    Group Name
                    <span class="text-danger ml-1">*</span>
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
                  <b-form-input type="text" v-if="lock" :value="model.groupname" plaintext></b-form-input>
                  <b-form-input md=12 type="text" v-else id="ph_name" v-model="model.groupname" :disabled="lock"></b-form-input>
                </b-col>
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_service">
                    Service
                    <span class="text-danger ml-1">*</span>
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12">
                  <v-select :readonly="true" @input="set_service" v-if="!lock || !model.service_name" label="service_name" v-model="model.service" :options="partner_service"></v-select>
                  <label v-else-if="model.service.id == null">{{model.service}}</label>
                  <h4 v-else>
                    <b-badge  :variant="model.service_name === 'Basic' ? 'info' : 'success'"> {{model.service_name}} </b-badge>
                  </h4>
                </b-col>
              </b-row>
              <b-row class="mb-2 mt-3">
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label mr-2" label-for="ph_credit">
                    Credit
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
                  <span class="label_sub">
                    $ {{model.credit | number}}
                  </span>
                </b-col>
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label mr-2" label-for="ph_count">
                    Member's
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
                  <span class="label_sub">
                    {{model.count | number}}
                  </span>
                </b-col>
              </b-row>
              <b-row class="mb-2 mt-3">
                <b-col class="col-xl-2">
                  <b-row>
                    <div class="col-xl-12 col-md-12 d-flex align-self-center">
                      <label class="col-form-label">
                        Usage Solution
                        (<b-button variant="link" @click="index = 3" class="px-0">Install History</b-button>)
                      </label>
                    </div>
                  </b-row>
                </b-col>
                <b-col class="col-xl-10">
                  <b-row>
                    <b-col class="col-xl-12 col-md-12 mb-2">
                      <b-badge class="mt-4" variant="danger">WebCastle : {{model.info.wc_count}} </b-badge>
                      <b-badge class="mt-4" variant="warning">WSFinder : {{model.info.wsf_count}} </b-badge>
                      <b-badge class="mt-4" variant="success">WMDS : {{model.info.wmds_count}} </b-badge>
                      <b-badge class="mt-4" variant="info">WFDetector : {{model.info.wf_count}} </b-badge>
                    </b-col>
                    <b-col class="col-xl-12 col-md-12 d-flex flex-wrap">
                      <b-row class="text-center">
                        <div class="col-xl-12 col-md-12 d-flex flex-wrap">
                          <div class="row  text-center">
                            <div class="col-xl-2">
                              <label class="col-form-label " for="Invoice11"  v-b-tooltip.hover title="Sets whether issued invoice is sent or not. Only 'Owner' accounts can be set.">
                                Invoice
                              </label>
                              <div class="checkbox-switch">
                                <input type="checkbox" class="input-checkbox" name="Invoice11" id="Invoice11" v-model="model.allow_invoice" :disabled="lock">
                                <div class="checkbox-animate">
                                  <span class="checkbox-off">OFF</span>
                                  <span class="checkbox-on">ON</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-xl-2">
                              <label class="col-form-label" for="Active">
                                Active
                              </label>
                              <div class="checkbox-switch">
                                <input type="checkbox" class="input-checkbox" name="Active" id="Active"  v-model="model.is_alive" :disabled="lock">
                                <div class="checkbox-animate">
                                  <span class="checkbox-off">OFF</span>
                                  <span class="checkbox-on">ON</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-xl-2">
                              <label class="col-form-label" for="Mail" v-b-tooltip.hover title="allow Notice alert mail(Detect, QNA, Notice, etc...)">
                                Mail
                              </label>
                              <div class="checkbox-switch">
                                <input type="checkbox" class="input-checkbox" name="Mail" id="Mail" v-model="model.allow_mail" :disabled="lock">
                                <div class="checkbox-animate">
                                  <span class="checkbox-off">OFF</span>
                                  <span class="checkbox-on">ON</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-xl-2">
                              <label class="col-form-label" for="Single_login" v-b-tooltip.hover title="single login Allow login.">
                                Single login
                              </label>
                              <div class="checkbox-switch">
                                <input type="checkbox" class="input-checkbox" name="Single_login" id="Single_login" v-model="model.single_login" :disabled="lock">
                                <div class="checkbox-animate">
                                  <span class="checkbox-off">OFF</span>
                                  <span class="checkbox-on">ON</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-xl-2">
                              <label v-if="model.is_del" class="col-form-label" for="Delete" v-b-tooltip.hover title="delete status">
                                Delete
                              </label>
                              <div v-if="model.is_del" class="checkbox-switch">
                                <input type="checkbox" class="input-checkbox" name="Delete" id="Delete" v-model="model.is_del" :disabled="lock">
                                <div class="checkbox-animate">
                                  <span class="checkbox-off">OFF</span>
                                  <span class="checkbox-on">ON</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mb-2 mt-3">
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_email">
                    Email
                    <span class="text-danger ml-1">*</span>
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12">
                  <b-form-input type="text" v-if="lock" :value="model.email" plaintext></b-form-input>
                  <b-form-input type="text" v-else id="ph_email" v-model="model.email" :disabled="lock"></b-form-input>
                </b-col>
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center" for="ph_contact">
                  <label class="col-form-label" for="ph_contact">
                    contact
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12">
                  <b-form-input type="text" v-if="lock" :value="model.contact" plaintext></b-form-input>
                  <b-form-input type="text" v-else id="ph_contact" v-model="model.contact" :disabled="lock"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="Address">
                    Address
                  </label>
                  <span class="text-danger ml-1">*</span>
                </b-col>
                <b-col class="col-xl-10 col-md-12">
                  <b-form-input type="text" v-if="lock" :value="model.address" plaintext></b-form-input>
                  <b-form-input md=12 type="text" v-else id="group_address" v-model="model.address" :disabled="lock"></b-form-input>
                </b-col>
              </b-row>
              <br>
              <div class="d-flex flex-wrap align-items-center">
                <div class="title_sub">
                  Region
                </div>
              </div>
              <hr>
              <b-row class="mb-2 mt-3">
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_country_group">
                    Country
                    <span class="text-danger ml-1">*</span>
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12">
                  <select class="form-control" @input="set_country" :disabled="lock" label="name" v-model="region.country">
                    <option v-for="(item, index) in codes.country" :key="index" :value="item">{{item.name}}</option>
                  </select>
                </b-col>
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_language_group">
                    language
                    <span class="text-danger ml-1">*</span>
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12">
                  <select class="form-control" @input="set_language" :disabled="lock" label="name" v-model="region.language">
                    <option v-for="(item, index) in codes.language" :key="index" :value="item">{{item.name}}</option>
                  </select>
                </b-col>
              </b-row>
              <b-row class="mb-2 mt-3">
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_timezone_group">
                    Timezone
                    <span class="text-danger ml-1">*</span>
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12">
                  <select class="form-control" @input="set_timezone" :disabled="lock" label="name" v-model="region.timezone">
                    <option v-for="(item, index) in codes.timezone" :key="index" :value="item">{{item.name}}</option>
                  </select>
                </b-col>
              </b-row>
              <b-row class="mb-2 mt-3">
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_syslog" v-b-tooltip.hover title="Enter a syslog server ip, ex) 192.168.0.100, 192.168.0.0/24 ">
                    Syslog
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12">
                  <b-form-textarea ref="syslog_list" :rows="model && model.syslog ? model.syslog.length + 2 : 0" max-rows="10" v-model="model.syslog_list" :plaintext="lock"></b-form-textarea>
                </b-col>
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_mail_cc" v-b-tooltip.hover title="Enter a email address for detect alert reference cc">Email CC</label>
                </b-col>
                <b-col class="col-xl-4 col-md-12">
                  <b-form-textarea ref="email_cc_list" :rows="model && model.mail_cc ? model.mail_cc.length + 2 : 0" max-rows="10" v-model="model.email_cc_list" :plaintext="lock"></b-form-textarea>
                </b-col>
              </b-row>
              <div class="mt-4">
                <b-button :disabled="model.is_del" v-if="!lock" size="sm" class="btn btn-add" @click="save"> Save </b-button>
                <b-button :disabled="model.is_del" v-else size="sm" variant="warning" @click="edit">
                  {{ model.is_del ? 'Group was deleted' : 'Edit'}}
                </b-button>
                <b-button :disabled="model.is_del" v-if="!lock" size="sm" variant="secondary" @click="cancel"> Cancel </b-button>
                <b-button :disabled="model.is_del" size="sm" variant="danger" @click="confirm = true;" v-if="model.id && lock && !model.is_del"> Remove </b-button>
                <b-button :disabled="model.is_del" size="sm" class="btn btn-addition" @click="send_ip_reset_mail" v-if="model.id && !model.is_del && lock"> Send IP ACL Reset Mail </b-button>
                <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
              </div>
            </b-card>
            <b-card>
              <partner-Detail v-if="model.partner_id && model.partner && !model.partner.is_del" :partner="model.partner"></partner-Detail>
            </b-card>
          </b-tab>
          <!-- start group's user -->
          <b-tab title="User list" border-variant="primary" :disabled="$route.params.id == 'add'">
            <b-card>
              <!-- start group's user -->
              <user-list v-if="model.id" :group="model" :view_detail="false"/>
            </b-card>
          </b-tab>
          <!-- end group's user -->

          <!-- start group's security_policy -->
          <b-tab title="Security policy" border-variant="primary" :disabled="$route.params.id == 'add'">
            <security-policy v-if="model.id" :group="model"/>
          </b-tab>
          <!-- end group's security_policy -->

          <!-- start group's user -->
          <!-- <b-tab title="WSFinder" border-variant="primary" >
            <wsfinder-list v-if="model.id && model.service != 'Basic'" :group="model" :delay="2"/>
          </b-tab> -->
          <!-- end group's user -->

          <!-- start group's user -->
          <!-- <b-tab title="WMDS" border-variant="primary" >
            <wmds-list v-if="model.id" :group="model" :delay="3"/>
          </b-tab> -->
          <!-- end group's user -->

          <!-- start group's user -->
          <!-- <b-tab title="WebCastle" border-variant="primary" >
            <webcastle-list v-if="model.id" :group="model" :delay="4"/>
          </b-tab> -->
          <!-- end group's user -->

          <!-- start group's install history -->
          <b-tab title="Install History" :disabled="$route.params.id == 'add'" @click="() => $refs._install_history ? $refs._install_history.refresh() : ''">
            <b-card>
              <InstallHistoryList v-if="model.id" ref="install_history" :user="model" />
            </b-card>
          </b-tab>
          <!-- end group's install history -->
          <!-- start group's Invoice -->
          <b-tab title="Invoice" :disabled="$route.params.id == 'add'" @click="() => $refs._install_history ? $refs._install_history.refresh() : ''">
            <b-card>
              <!-- ss -->
              <InvoiceHistoryList v-if="model.id" :group_id="model.id" ref="_list_invoice" />
              <hr>
              <b-button size="sm" class="pull-right" variant="primary" @click="confirm_ticket_invoice = true;" v-if="model.id"> Ticket Invoice </b-button>
            </b-card>
          </b-tab>
          <!-- end group's Invoice -->
          <!-- start group's Invoice -->
          <b-tab title="QNA" :disabled="$route.params.id == 'add'" @click="() => $refs._install_history ? $refs._install_history.refresh() : ''">
            <b-card>
              <!-- user == group -->
              <QNAList v-if="model.id" :group="model" :only_view="true" />
            </b-card>
          </b-tab>
          <!-- end group's Invoice -->
        </b-tabs>
      </b-col>
    </b-row>

    <router-view></router-view>
    <!-- modal area -->
    <b-modal title="Remove"  class="modal-danger" header-bg-variant="danger"  v-model="confirm" @ok="remove" ok-variant="outline-danger" cancel-variant="outline-dark">
      If this group have user, can't log in after removed
      <br>
      Check first, this  group's user
      <br>
      At the time of deletion, the subscription information currently used will be deleted.
      <br>
      Would You Like to Remove the group?
    </b-modal>
    <!-- 인보이스 발급 년월 선택 -->
    <b-modal title="Ticket Invoice"  class="modal-dark" v-model="confirm_ticket_invoice" @ok="ticket_invoice" ok-variant="outline-primary" cancel-variant="outline-dark">
      <b-form-group>
        <p>please select the month of invoice</p>
        <hr>
        <!-- <vue-monthly-picker selectedBackgroundColor="blue" alignment="center" dateFormat="YYYY-MM" style="width: 100%;" v-model="ticket_invoice_month"> </vue-monthly-picker> -->
        <date-picker style="width: 100%;" type="month" v-model="ticket_invoice_month" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
        <hr>
        <small class="text-danger font-weight-bold">
          If it's already issued, force it to be issued.
          <br>
          Please check the amount of invoice generated.
          <br>
          An information mail will be sent when the invoice is issued.
        </small>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>